import React from 'react'
import {
  TableItemBody,
  TableItemContainer,
} from 'components/Table/Table.styled'
import { PastPurchaseItemText } from './PastPurchase.styled'
import { PastPurchaseItemProps } from './PastPurchase.props'
import moment from 'moment'
import Alert from 'components/Alert'
import { PENNIES } from 'utils/rate'

const PastPurchaseItem: React.FC<PastPurchaseItemProps> = ({
  transaction,
  onClick,
}) => {
  return (
    <TableItemContainer onClick={() => onClick(transaction)}>
      <TableItemBody>
        <PastPurchaseItemText>
          {moment(transaction.created_at).format('MM/DD/YYYY')}
        </PastPurchaseItemText>
      </TableItemBody>
      <TableItemBody>
        <PastPurchaseItemText>
          $ {(transaction.amount / PENNIES).toFixed(2)}
        </PastPurchaseItemText>
      </TableItemBody>
      <TableItemBody>
        <PastPurchaseItemText>{transaction.description}</PastPurchaseItemText>
      </TableItemBody>
      <TableItemBody>
        {transaction.paid === 'paid' && (
          <Alert msg={transaction.paid} type={'success'} />
        )}
        {transaction.paid === 'unpaid' && (
          <Alert msg={transaction.paid} type={'danger'} />
        )}

        <PastPurchaseItemText></PastPurchaseItemText>
      </TableItemBody>
    </TableItemContainer>
  )
}

export default PastPurchaseItem
